module.exports = __webpack_public_path__ + "static/media/reports_section_balancing_report.c6c29a0c.mov";